import BookMaker from '@/models/BookMaker'
import Api from '@/services/api'
import { each, find } from 'lodash'
import map from 'lodash/map'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    articleDetails: {},
    requestStatus: '',
    requestMsg: ''
  },

  mutations: {
    setRequestStatus (state, payload) {
      state.requestMsg = payload.msg
      state.requestStatus = payload.status
    },

    setBooksList (state, books) {
      each(books, book => {
        const exist = find(state.list, { id: book.id })
        if (!exist) {
          state.list.push(new BookMaker(book))
        }
      })
    },

    setFreshBooksList (state, bookmakers) {
      state.list = map(bookmakers, bookmaker => {
        if (bookmaker instanceof BookMaker) {
          return bookmaker
        } else {
          return new BookMaker(bookmaker)
        }
      })
    },

    addDuplicateBookItem (state, book) {
      console.log(book)
      state.list.unshift(book)
    },

    setListMeta (state, meta) {
      state.listMeta = meta
    },

    refreshList (state) {
      state.list = []
    }
  },

  actions: {
    async getBookList ({ commit }, params) {
      let perPage = 20
      if (params.per_page) {
        perPage = params.per_page
      }
      const query = BookMaker.page(params.page || 1)
        .orderBy(params.sort)

      if (params.location) {
        query.where('location', params.location)
      }

      if (perPage === 'all') {
        query.params({ limit: 'all' })
      } else {
        query.limit(perPage)
      }
      const res = await query.get()

      commit('setBooksList', res.data)
      commit('setListMeta', res.meta)
    },

    async getFreshBookList ({ commit }, params) {
      let perPage = 20
      if (params.per_page) {
        perPage = params.per_page
      }
      const query = BookMaker.page(params.page || 1)
        .orderBy(params.sort)
        .limit(perPage)
      if (params.location) {
        query.where('location', params.location)
      }
      const res = await query.get()

      commit('setFreshBooksList', res.data)
    },

    async createSportsBook ({ commit }, params) {
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }

      await Api.post(`admin/bookmakers`, params, config)
        .then(response => {
          let payload = { msg: 'SportsBook Created.', status: 'success' }
          commit('setRequestStatus', payload)
          commit('refreshList')
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async getBookMaker ({ commit }, params) {
      let res = await BookMaker.find(params.id)

      return res
    },

    async updateSportBook ({ commit }, params) {
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      let id = params.get('id')
      await Api.post('admin/bookmakers/' + id, params, config)
        .then(response => {
          let payload = { msg: 'SportsBook Updated.', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async deleteSportsBook ({ commit }, params) {
      await Api.delete(`admin/bookmakers/${params.id}`)
        .then(response => {
          let payload = { msg: 'SportsBook Deleted.', status: 'error' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async duplicateSportsBook ({ commit }, params) {
      let id = params.id

      await Api.post(`admin/bookmakers/${id}/duplicate`, params)
        .then(response => {
          let payload = { msg: 'SportsBook Duplicated', status: 'success' }

          commit('setRequestStatus', payload)
          commit('addDuplicateBookItem', response.data.data)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async updateBookLogo ({ commit }, params) {
      let id = params.get('id')

      await Api.post(`admin/bookmakers/${id}/logo`, params)
        .then(response => {
          let payload = { msg: 'SportsBook Logo Updated.', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async deleteBookLogo ({ commit }, params) {
      let id = params.get('id')

      await Api.delete(`admin/bookmakers/${id}/logo`)
        .then(response => {
          let payload = { msg: 'Old SportsBook Logo Removed.', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async updateBookBanner ({ commit }, params) {
      let id = params.get('id')

      await Api.post(`admin/bookmakers/${id}/banner-logo`, params)
        .then(response => {
          let payload = { msg: 'SportsBook Logo Updated.', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async deleteBookBanner ({ commit }, params) {
      let id = params.get('id')

      await Api.delete(`admin/bookmakers/${id}/banner-logo`)
        .then(response => {
          let payload = { msg: 'Old SportsBook Banner Removed.', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async updateBookWelcomeImage ({ commit }, params) {
      let id = params.get('id')

      await Api.post(`admin/bookmakers/${id}/welcome-logo`, params)
        .then(response => {
          let payload = { msg: 'SportsBook Welcome Image Updated.', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async deleteBookWelcomeImage ({ commit }, params) {
      let id = params.get('id')

      await Api.delete(`admin/bookmakers/${id}/welcome-logo`)
        .then(response => {
          let payload = { msg: 'Old SportsBook Welcome Image Removed.', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async updateReviewAvatar ({ commit }, params) {
      let id = params.get('id')

      await Api.post(`admin/bookmakers/${id}/review-avatar`, params)
        .then(response => {
          let payload = { msg: 'SportsBook Review Author Image Updated.', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async deleteReviewAvatar ({ commit }, params) {
      let id = params.get('id')

      await Api.delete(`admin/bookmakers/${id}/review-avatar`)
        .then(response => {
          let payload = { msg: 'Old SportsBook Review Author Image Removed.', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    refreshList ({ commit }) {
      commit('refreshList')
    },

    async updateImageMeta ({ commit }, params) {
      let id = params.get('id')

      await Api.post(`admin/bookmakers/${id}/image-meta`, params)
        .then(response => {
          let payload = { msg: 'SportsBook Image Meta Updated.', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async deleteImageMeta ({ commit }, params) {
      let id = params.get('id')

      await Api.delete(`admin/bookmakers/${id}/image-meta`)
        .then(response => {
          let payload = {
            msg: 'Old SportsBook Image Meta Removed.',
            status: 'success'
          }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async updateSmallLogo ({ commit }, params) {
      let id = params.get('id')

      await Api.post(`admin/bookmakers/${id}/small-logo`, params)
        .then(response => {
          let payload = {
            msg: 'SportsBook Small Logo Updated.',
            status: 'success'
          }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async updateWelcomePromoLogo ({ commit }, params) {
      let id = params.get('id')

      await Api.post(`admin/bookmakers/${id}/welcome-promo-logo`, params)
        .then(response => {
          let payload = {
            msg: 'SportsBook Welcome Promo Logo Updated.',
            status: 'success'
          }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async unBoard ({ commit }, id) {
      let { data } = await Api.put(`admin/bookmakers/${id}/unboard`)

      return data
    },

    async onBoard ({ commit }, id) {
      let { data } = await Api.put(`admin/bookmakers/${id}/onboard`)

      return data
    },

    async updateOnboardingOrder ({ commit }, params) {
      let { data } = await Api.post(`admin/bookmakers/onboarding-order`, params)

      return data
    }
  }
}
